import API_BASE, { getAuthToken } from "./apiClient";

export const storage = {};
export function ref(_storage, path) { return { path }; }

async function upload(file, path, onProgress) {
  const formData = new FormData();
  formData.append("file", file, file.name || path.split("/").pop());
  const token = path.startsWith("artwork/") ? null : getAuthToken(); // customer artwork always uses the public endpoint
  const headers = token ? { Authorization: `Bearer ${token}` } : {};
  const endpoint = token ? "/api/admin/files/upload" : "/api/uploads";
  if (token) formData.append("path", path.split("/").slice(0, -1).join("/") || "product-images");
  const response = await fetch(`${API_BASE.replace(/\/api$/, "")}${endpoint}`, { method: "POST", headers, body: formData });
  const contentType = response.headers.get("content-type") || "";
  const data = contentType.includes("application/json")
    ? await response.json()
    : { error: `Upload endpoint returned HTTP ${response.status}. Check that the API is running and the admin session is valid.` };
  if (!response.ok) throw new Error(data.error || `Upload failed (HTTP ${response.status})`);
  onProgress?.(100);
  return { ref: { path: data.url } };
}

export function uploadBytes(fileRef, file) { return upload(file, fileRef.path); }
export function uploadBytesResumable(fileRef, file) {
  const task = { snapshot: { ref: fileRef }, on: (event, progress, error, complete) => {
    upload(file, fileRef.path, value => progress?.({ bytesTransferred: value, totalBytes: 100 }))
      .then(result => { task.snapshot.ref = result.ref; complete?.(); })
      .catch(error);
  } };
  return task;
}
export async function getDownloadURL(fileRef) { return fileRef.path; }
export async function deleteObject() {}